import { useEffect, useState } from 'react';
import { notification, Table, Pagination, Empty, Row, Col, Card, Badge, Button } from "antd";

import { getDeviceProfiles, getDeviceProfiles2 } from "@axios/api.device";

import { useTranslation } from "react-i18next";

interface propsModel {
    id: string,
}

const { Column } = Table;

export const DeviceDetailProfiles = (props: propsModel) => {
    const { id } = props;
    const [data, setData] = useState<any>();
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [data2, setData2] = useState<any>();
    const [pageIndex2, setPageIndex2] = useState<number>(1);
    const [pageSize2, setPageSize2] = useState<number>(10);
    const [totalCount2, setTotalCount2] = useState<number>(0);
    
    const { t } = useTranslation();

    const statusMapping: any = {
        "Pending": t("Pending"), 
        "PartialSuccess": t("PartialSuccess"), 
        "Failed": t("Failed"), 
        "Success": t("Success")
    };

    useEffect(() => { if (id) { 
        getData();
        getData2();
    } }, []);

    const getData = (index=pageIndex, size=pageSize) => {
        getDeviceProfiles(id, {pageIndex: index, pageSize: size}).then(
            (res) => {
                const { dataList, pageIndex, pageSize, totalCount } = res;
                if (dataList.length > 0) {
                    dataList.map((item: any, itemIndex: number) => {
                        item["index"] = itemIndex;
                        return item;
                    })
                }
                setData(dataList);
                setPageIndex(pageIndex);
                setPageSize(pageSize);
                setTotalCount(totalCount);     
            },
            () => { notification.error({message: t("获取设备描述文件失败")}) },
        )
    }

    const getData2 = (index=pageIndex2, size=pageSize2) => {
        getDeviceProfiles2(id, {pageIndex: index, pageSize: size}).then(
            (res) => {
                const { dataList, pageIndex, pageSize, totalCount } = res;
                if (dataList.length > 0) {
                    dataList.map((item: any, itemIndex: number) => {
                        item["index"] = itemIndex;
                        return item;
                    })
                }
                setData2(dataList);
                setPageIndex2(pageIndex);
                setPageSize2(pageSize);
                setTotalCount2(totalCount);     
            },
            () => { notification.error({message: t("获取设备描述文件失败")}) },
        )
    }

    return (
        <>
            <Row gutter={16} style={{marginBottom: "15px"}}>
                <Col span={12}>
                    <Card title={t("配置文件")} bodyStyle={{padding: 0, height: 430}}>
                        <Table 
                            dataSource={data2} 
                            pagination={false} 
                            rowKey="index"
                            scroll={data2?.length > 8 ? {y: 380} : {}}
                            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                        >
                            <Column title={t("名称")} key="templateName" dataIndex="templateName"></Column>
                            <Column 
                                title={t("状态")} 
                                key="state" 
                                dataIndex="state"
                                render={(v) => {
                                    return <>{v ? <Badge color={v === "Failed" ? "red" : "green"} text={statusMapping[v]}></Badge> : ""}</>
                                }}
                            ></Column>
                        </Table>
                    </Card>
                    <Pagination
                        style={{textAlign: 'right', marginTop: '20px'}}
                        current={pageIndex2}
                        pageSize={pageSize2}
                        total={totalCount2}
                        showTotal={(total, range) => `${range[0]}-${range[1]} / ${total}${t("条")}`}
                        onChange={(page, pageSize) => { getData2(page, pageSize) }}
                        onShowSizeChange={(current, size) => { getData2(current, size) }}
                    ></Pagination>
                </Col>
                <Col span={12}>
                    <Card title={t("描述文件")} bodyStyle={{padding: 0, height: 430}}>
                        <Table 
                            dataSource={data} 
                            pagination={false} 
                            rowKey="index"
                            scroll={data?.length > 8 ? {y: 380} : {}}
                            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                        >
                            <Column title={t("名称")} key="payloadDisplayName" dataIndex="payloadDisplayName"></Column>
                            <Column title={t("描述")} key="payloadDescription" dataIndex="payloadDescription"></Column>
                            <Column title={t("版本")} key="payloadVersion" dataIndex="payloadVersion"></Column>
                        </Table>
                    </Card>
                    <Pagination
                        style={{textAlign: 'right', marginTop: '20px'}}
                        current={pageIndex}
                        pageSize={pageSize}
                        total={totalCount}
                        showTotal={(total, range) => `${range[0]}-${range[1]} / ${total}${t("条")}`}
                        onChange={(page, pageSize) => { getData(page, pageSize) }}
                        onShowSizeChange={(current, size) => { getData(current, size) }}
                    ></Pagination>
                </Col>
            </Row>
        </>
    )
}

